// @flow

import React from "react";
import ReactTable, { ReactTableDefaults } from "react-table";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import { zoomTableConfig, zoomTableActionsConfig } from "./zoomTableConfig";
import { getUniqueId } from "../../../services/helpers";
import styles from "./zoomTable.scss";

const CheckboxTable = checkboxHOC(ReactTable);

// Quietly using react-table inside

type Props = {
  configKey: string, // table config key is to be in sync with state.tabConfig.currentSelectedTab
  tableData: Array<Object>,
  actionFunctions?: Object,
  tableDataLength: number,
  paginationProps?: Object,
  onChangeSelection?: Function,
  selectionIdAccessor?: string
};

type State = {
  selection: Array<any>,
  selectAll: Boolean
};

class ZoomTable extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.checkBoxTable = null;
    this.state = {
      selection: [],
      selectAll: false
    };
    this.tableData = this.props.tableData;
    this.selectTableData = this.getData(this.props.tableData);
    // Below step will append action button on-click handlers now
    zoomTableActionsConfig[
      this.props.configKey
    ].actions = this.props.actionFunctions;
    this.setReactTableProps();
  }

  componentWillReceiveProps(nextProps) {
    // Update tableData
    this.tableData = nextProps.tableData;
    this.tableDataLength = nextProps.tableData.length;
    this.setReactTableProps();
  }

  getData(testData) {
    const data =
      testData &&
      testData.map(item => {
        // using chancejs to generate guid
        // shortid is probably better but seems to have performance issues
        // on codesandbox.io
        const _id = item[this.props.selectionIdAccessor] || getUniqueId(3);
        return Object.assign({}, item, { _id });
      });
    return data;
  }

  setReactTableProps() {
    Object.assign(ReactTableDefaults, {
      // defaultPageSize: Math.min(
      //   this.tableData.length,
      //   zoomTableConfig[this.props.configKey].minRows
      // ),
      //  defaultPageSize: zoomTableConfig[this.props.configKey].minRows,
      // minRows: Math.min(
      //   this.tableData.length,
      //   zoomTableConfig[this.props.configKey].minRows
      // ),
      // minRows: zoomTableConfig[this.props.configKey].minRows,

      showPageSizeOptions: false,
      manual:
        this.props.paginationProps &&
        this.props.paginationProps.serverSidePagination,
      // pageSizeOptions: zoomTableConfig[this.props.configKey].pageSizeOptions,
      onPageChange: page => this.handleOnPageChange(page),
      page: this.props.paginationProps && this.props.paginationProps.pageNumber,
      showPagination:
        (this.props.paginationProps &&
          this.props.paginationProps.showPagination) ||
        false, // this.tableData && this.tableData.length > 0,
      defaultPageSize:
        (this.props.paginationProps &&
          this.props.paginationProps.tableDataLength) ||
        this.props.tableDataLength,
      pageSize:
        (this.props.paginationProps && this.props.paginationProps.pageSize) ||
        this.tableDataLength,
      noDataText: zoomTableConfig[this.props.configKey].noDataText,
      style: zoomTableConfig[this.props.configKey].style,
      pages: this.props.paginationProps
        ? this.props.paginationProps.pages
        : null
    });
  }

  handleOnPageChange(page) {
    if (this.props.paginationProps && this.props.paginationProps.onPageChange) {
      this.props.paginationProps.onPageChange(page);
    }
  }

  isSelected(key) {
    return this.state.selection.includes(key);
  }

  toggleAll() {
    const selectAll = !this.state.selectAll;
    const selection = [];
    if (selectAll) {
      const wrappedInstance = this.checkBoxTable.getWrappedInstance();
      // the 'sortedData' property contains the currently accessible records based on the filter and sort
      const currentRecords = wrappedInstance.getResolvedState().sortedData;
      // we just push all the IDs onto the selection array
      currentRecords.forEach(item => {
        selection.push(item._original._id);
      });
    }
    this.setState({ selectAll, selection }, () =>
      this.props.onChangeSelection(selection)
    );
  }

  toggleSelection(key) {
    let selection = Object.assign([], this.state.selection);
    const keyIndex = selection.indexOf(key);
    if (keyIndex >= 0) {
      selection = Object.assign([], selection.slice(0, keyIndex)).concat(
        Object.assign([], selection.slice(keyIndex + 1))
      );
    } else {
      selection.push(key);
    }
    this.setState({ selection }, () => this.props.onChangeSelection(selection));
  }

  render() {
    return (
      <div
        className={`${
          styles[zoomTableConfig[this.props.configKey].className]
        } zoom-table-wrapper`}
      >
        {!this.props.onChangeSelection ? (
          <ReactTable
            data={this.tableData}
            columns={zoomTableConfig[this.props.configKey].columns}
          />
        ) : (
          <CheckboxTable
            ref={el => {
              this.checkBoxTable = el;
            }}
            data={this.selectTableData}
            columns={zoomTableConfig[this.props.configKey].columns}
            selectAll={this.state.selectAll}
            isSelected={key => this.isSelected(key)}
            toggleSelection={key => this.toggleSelection(key)}
            toggleAll={() => this.toggleAll()}
            selectType="checkbox"
            getTrProps={(s, r) => {
              const selected = this.isSelected(r.original._id);
              return {
                style: {
                  backgroundColor: selected ? "lightgreen" : "inherit"
                }
              };
            }}
          />
        )}
      </div>
    );
  }
}

ZoomTable.defaultProps = {
  actionFunctions: {},
  paginationProps: null,
  selectionIdAccessor: null,
  onChangeSelection: null
};

export default ZoomTable;



// WEBPACK FOOTER //
// ./app/components/commons/zoomTable/zoomTable.js